module.exports = __webpack_public_path__ + "img/photograph1.36b69084.png";